import { Box } from '@mui/material';
import { MUIStyledCommonProps } from '@mui/system';
import { Theme } from '@emotion/react';


type PropsItem = {
	percent: number;
} & MUIStyledCommonProps<Theme>;

const IMQuestionsProgressBarItem = ({ percent, sx, ...props }: PropsItem) => {
	const progressWidth = Math.min(100 * percent, 100);

	return (
		<Box
			sx={{
				flex: 1,
				height: '4px',
				backgroundColor: '#DEDEDE',
				borderRadius: '1px',
				...sx,
			}}
			{...props}
		>
			<Box
				sx={{
					height: '100%',
					borderRadius: '1px',
					width: `${progressWidth}%`,
					backgroundColor: '#39B54A',
					overflow: 'hidden',
					...sx,
				}}
				{...props}
			>

			</Box>
		</Box>
	);
};

type Props = {
	questionIndex: number;
	totalStages: number;
	itemsCountInARow?: number;
} & MUIStyledCommonProps<Theme>;

const IMQuestionsProgressBar = ({ questionIndex, totalStages, itemsCountInARow, sx, ...props }: Props) => {
	const backgroundColor = '#F6F6F6';
	const questionsCountInRow = itemsCountInARow ?? 5;
	const currentStageIndex = Math.floor(questionIndex / questionsCountInRow);
	const qIndexInStage = questionIndex - currentStageIndex * questionsCountInRow;
	return (
		<Box
			sx={{
				backgroundColor,
				display: 'flex',
				alignItems: 'center',
				height: '20px',
				gap: '4px',
				px: '12px',
				flexShrink: 0,
				...sx,
			}}
			{...props}
		>
			{Array.from({ length: totalStages }).map((_, idx) => (
				<IMQuestionsProgressBarItem
					key={`${idx}-${totalStages}`}
					percent={
						currentStageIndex > idx ? 1 :
							(currentStageIndex === idx ? qIndexInStage / questionsCountInRow : 0)}
				/>
			))}
		</Box>
	);
};


export default IMQuestionsProgressBar;
